import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Layout from "../inc/layout-frontend";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Button, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { logoutRequest } from "../../backend/auth/logout";
import { resetAuthData } from "../../app/providers/authSlice";
import { resetCart } from "../../app/providers/panierSlice";
import Swal from "sweetalert2";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import PaysService from "../../services/PaysService";
import RolesusersService from "../../services/RolesusersService";
import CommandesService from "../../services/CommandesService";
import RolesService from "../../services/RolesService";
import ModepaiementsService from "../../services/ModepaiementsService";
import { app_url } from "../../services/http";
import PublicationsService from "../../services/PublicationsService";
import PeriodiquesService from "../../services/PeriodiquesService";
import DetailsCommandesService from "../../services/DetailsCommandesService";

export default function Moncompte(){

  const [pays, setPays] = useState([]);

  // Déclaration de l'état initial pour rolesusers
  const [rolesusers, setRolesusers] = useState([]);

  const [roles, setRoles] = useState([]);

  const [modepaiements, setModepaiements] = useState([]);

  const [publications, setPublications] = useState([]);

  const [commandesEnAttente, setCommandesEnAttente] = useState([]);

  const [statutEnAttente, setStatutEnAttente] = useState('');


  const [paiementsUtilisateur, setPaiementsUtilisateur] = useState([]);

  const [periodiques, setPeriodiques] = useState([]);

  const test = useSelector((state) => state.panier.countPanier);


  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  // récupérer la liste des pays

  useEffect(() => {
    PaysService.index()
      .then(response => {
        if (Array.isArray(response.data.pays)) {
          setPays(response.data.pays);
        } else {
          console.error('La réponse ne contient pas un tableau de pays:', response.data);
        }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des pays:', error);
      });

  }, []);

  // rechercher le libellé du pays correspondant grâce à l'id de pays 

  const paysLibelle = pays.find((pays) => pays.id === auth.user?.pays_id);

  // se déconnecter
	const handleLogout = () => {    
		logoutRequest(auth.token);
		dispatch(resetAuthData());
        dispatch(resetCart());
        Swal.fire({
            icon: "success",
                    title: 'Vous vous êtes déconnectée avec succès',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "green",
                    color: "white",
                    iconColor: "white"
          });
	}

 
    const fetchRolesusers = async () => {
      try {
        const response = await RolesusersService.index_roles_users();
        const data = response.data.rolesusers;
        const RolesusersArray = Array.isArray(data) ? data : Object.values(data);
        setRolesusers(RolesusersArray);
      // console.log(RolesusersArray)

      

      } catch (error) {
        console.log(error);
      }
    };

    const fetchRoles = async () => {
      try {
        const response = await RolesService.index_roles();
        const data = response.data.roles;
        const RolesArray = Array.isArray(data) ? data : Object.values(data);
        setRoles(RolesArray);
      //console.log(RolesArray)

      } catch (error) {
        console.log(error);
      }
    };
    
  // récupérer le libelle du role à partir de l'id
    const roleId = rolesusers.find(roleUser => roleUser.users_id === (auth.user && auth.user.id))?.roles_id;
    const roleLibelle = roles.find(role => role.id === roleId)?.libelle;

    //console.log("roleLibelle :" , roleLibelle);

     //get publications
  const fetchPublications = async () => {
    try {
      const response = await PublicationsService.index();
      setPublications(response.data.publications); // Utilisez response.data.publications au lieu de response.data
      //console.log(response.data.publications)
      // Récupérer les libellés des périodiques à partir des IDs
      const ids = response.data.publications.map(publication => publication.periodique_id);
      const periodiquesResponse = await PeriodiquesService.index(ids);
      setPeriodiques(periodiquesResponse.data.liste_periodiques);
    } catch (error) {
      console.log(error);
    }
  };

  

    const fetchPaiements = async () => {
      try {
       // console.log(auth.token)
        const response = await CommandesService.index_paiement(auth.token);
        const data = response.data.commandes;

        const Detailsresponse = await CommandesService.detailscommandes(auth.token);
        const Detailsdata = response.data.detailsCommandes;

       
        for (const commandeId in Detailsdata) {
          if (Detailsdata.hasOwnProperty(commandeId)) {
            const detailsCommande = Detailsdata[commandeId];

           // Récupérer le titre et le chemin de l'image de chaque publication
            const publicationsInfo = detailsCommande.map((detail) => ({
              titre: detail.titre,
              image: app_url + "/storage/laune/" + detail.laune_path,
              pdf: detail.publication_path ? app_url + "/storage/publications/" + detail.publication_path : null

            }));
         
          }
        }

        const paiementsUtilisateur = data
          .filter(paiement => auth.user && paiement.created_by === auth.user.id) // Remplacez utilisateurConnecteId par l'ID de l'utilisateur connecté
          .map(  paiement => {
           // Récupérer les détails de commande associés à la commande actuelle (paiement)
       // const paiementDetails = Detailsdata.filter((detail) => detail.commande_id === paiement.id);

        
        // Exemple : Trouver les ID des détails de commande associés à une commande commande
        const commandeId = paiement.id;
        const detailsCommande = Detailsdata[commandeId];
        const publicationIds = detailsCommande.map((detail) => detail.titre);

            // Récupérer les informations complètes des publications associées à cette commande
        const publicationsInfo = detailsCommande.map((detail) => ({
          titre: detail.titre,
          image: app_url + "/storage/laune/" + detail.laune_path,
          pdf: detail.publication_path ? app_url + "/storage/publications/" + detail.publication_path : null
        }));
        /*const modePaiement = modePaiements.find(mode => mode.id === paiement.modepaiement_id);
        const libelleModePaiement = modePaiement ? modePaiement.libelle : '';
*/

        // formater la date en jour mois et année
        
          const date = new Date(paiement.created_at);
          const jour = date.getDate();
          const mois = date.toLocaleString('default', { month: 'long' });
          const annee = date.getFullYear();

         
            
        // Récupérer les informations complètes des publications associées à chaque commande

            return {
              id: paiement.id,
              reference: paiement.reference,
              montant: paiement.montant_total,
              statut: paiement.statut_transaction,
              datePaiement: `${jour} ${mois} ${annee}`,
              publicationsInfo: publicationsInfo, // Ajouter les informations complètes des publications au paiement
            };
         
        });
        
          setPaiementsUtilisateur(paiementsUtilisateur)
       // console.log(paiementsUtilisateur);
        // Utilisez paiementsUtilisateur comme vous le souhaitez, par exemple, le stocker dans l'état du composant.
      } catch (error) {
        console.log(error);
      }
    };


    /**************************************Méthodes pour les commandes en attente de paiements **********************/


    const fetchCommandesEnAttente = async () => {
      try {
       // console.log(auth.token)

       const response = await CommandesService.index_paiement(auth.token);
       const attentedata = response.data.commandes_en_attente;


       const Detailsresponse = await CommandesService.detailscommandes(auth.token);
       const Detailsdata = response.data.detailsCommandes;

       //récupérer l'id des stauts en attentes

       

       setStatutEnAttente(response.data.statut_en_attente);

      
       //console.log("commandeId", response.data.detailsCommandes)


        //console.log( response.data.statut_en_attente);

        for (const commandeId in Detailsdata) {
          if (Detailsdata.hasOwnProperty(commandeId)) {
            const detailsCommande = Detailsdata[commandeId];

           // Récupérer le titre et le chemin de l'image de chaque publication
            const publicationsInfo = detailsCommande.map((detail) => ({
              titre: detail.titre_concatene,
              image: app_url + "/storage/laune/" + detail.laune_path,
              statut_id: detail.statut_id,
            }));
         
          }
        }

       // console.log(attentedata)

        const commandesEnAttente = attentedata
          .filter(commande => auth.user && commande.created_by === auth.user.id) // Remplacez utilisateurConnecteId par l'ID de l'utilisateur connecté
          .map(  commande => {
         
        const commandeId = commande.id;
        const detailsCommande = Detailsdata[commandeId];

            // Récupérer les informations complètes des publications associées à cette commande
        const publicationsInfo = detailsCommande.map((detail) => ({
          titre: detail.titre_concatene,
          image: app_url + "/storage/laune/" + detail.laune_path,
          statut_id: detail.statut_id,
        }));
        /*const modePaiement = modePaiements.find(mode => mode.id === paiement.modepaiement_id);
        const libelleModePaiement = modePaiement ? modePaiement.libelle : '';
*/

        // formater la date en jour mois et année
        
          const date = new Date(commande.created_at);
          const jour = date.getDate();
          const mois = date.toLocaleString('default', { month: 'long' });
          const annee = date.getFullYear();

         
            
        // Récupérer les informations complètes des publications associées à chaque commande

            return {
              id: commande.id,
              reference: commande.reference,
              montant: commande.montant_total,
              dateCreation: `${jour} ${mois} ${annee}`,
              publicationsInfo: publicationsInfo, // Ajouter les informations complètes des publications au paiement
            };
         
        });
        
          setCommandesEnAttente(commandesEnAttente)
       // console.log(paiementsUtilisateur);
        // Utilisez paiementsUtilisateur comme vous le souhaitez, par exemple, le stocker dans l'état du composant.
      } catch (error) {
        console.log(error);
      }
    };
    
      // Fonction pour récupérer les commandes en attente
     /* const fetchCommandesEnAttente = async () => {
        try {
          const response = await CommandesService.index_paiement(auth.token);
          const commandesEnAttenteData = response.data.commandes_en_attente;
          setCommandesEnAttente(commandesEnAttenteData);
         
        } catch (error) {
          console.log(error);
        }
      };*/

      // Fonction pour formater la date au format jour mois année
    
      const Handlepaiementpage = async (params_commande_id) => {
        try{

        navigate(myroutes.paiement,{state:{statut_id:statutEnAttente, commande_id:params_commande_id}})

        //console.log(statutEnAttente)

        }catch(error){

        }
      }
    
    const fetchModepaiements = async () => {
      try {
        const response = await ModepaiementsService.index_modepaiements();
        setModepaiements(response.data.modepaiements);
        //alert(auth.user.id);
       // console.log(response.data.modepaiements);
      } catch (error) {
        console.error(error);
      }
  
    };
   
useEffect(() => {
    fetchRoles();
    fetchRolesusers();
    fetchPublications();
    fetchPaiements();
    fetchModepaiements();
    fetchCommandesEnAttente();
  }, []);

  
  const navigate = useNavigate();

 /*   const showPdf = async (url) => {

    if (!url) {
        Swal.fire({
            icon: 'error',
            text: "Cette publication ne contient pas de PDF !",
        });
    } else {
        try {
        iframe.src = url;
          iframe.width = '100%';
          iframe.height = '500px';

          // Supprimer tout contenu existant dans le conteneur avant d'ajouter l'iframe
          const pdfContainer = document.getElementById('pdf-container');
          pdfContainer.innerHTML = '';
          pdfContainer.appendChild(iframe);

          Swal.fire({
            icon: 'success',
            text: 'PDF affiché !',
          });

           // Afficher le PDF dans l'iframe
           // Utilisez useHistory pour obtenir l'objet history
           
              } catch (error) {
                  console.log('Erreur lors du téléchargement du fichier :', error);
              }
          }
      }*/

      const showPdf = (pdfUrl, documentTitle) => {
        if (pdfUrl) {
          // Naviguer vers la page de consultation avec l'URL du PDF et le titre du document en tant que paramètres
          window.location.href = `${myroutes.consultation}?pdfUrl=${encodeURIComponent(pdfUrl)}&documentTitle=${encodeURIComponent(documentTitle)}`;
        } else {
          // Afficher un message si l'URL du PDF n'existe pas
          Swal.fire({
            icon: 'error',
            text: 'Ce document n\'a pas de PDF !',
          });
        }
      };

    return(
        <Layout> 
        {/** Navbar Start */}
  <div className="container-fluid position-relative p-0">
              <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom:"90px" }}>
          <div className="row py-5">
              <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                  <h1 className="display-4 text-white animated zoomIn">Mon compte</h1>
                  <Link className="h5"  style={{ color:"goldenrod"}} to={myroutes.homepage}>
                  Accueil
                  </Link>
                  <i className="far fa-circle text-white px-2"></i>
                  <Link className="h5 text-white" >
                    Tableau de bord
                  </Link>
              </div>
          </div>
      </div>
  </div>
  {/** Navbar End */}
<div className="container">
  <div className="row" >
  <Tabs
  defaultActiveKey="dashboard"
  id="fill-tab-example"
  className="nav-tab mb-5 p-3"
  fill
  variant="pills"
 
>
  <Tab eventKey="dashboard" title="Tableau de bord">
    <div className="tab-content">
    <h3 className="mb-4" style={{color:"#116BB9"}}>
    <button type="button" class="btn btn-warning btn-lg btn-floating me-3">
      <i class="fas fa-money-bill-1-wave"></i>
    </button>
      Mes récents achats validés
      </h3>
            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>
            <div className="table-responsive">
    <table className="table table-striped">
      <thead>
        <tr>
          <th scope="col" style={{color:"#116BB9"}}>#</th>
          <th scope="col" style={{color:"#116BB9"}}>Référence</th>
          <th scope="col" style={{color:"#116BB9"}}>Montant</th>
          <th scope="col" style={{color:"#116BB9"}}>Packages</th>
          <th scope="col" style={{color:"#116BB9"}}>Mes documents</th>
          <th scope="col" style={{color:"#116BB9"}}>Date paiement</th>
          <th scope="col" style={{color:"#116BB9"}}>Date d'expiration</th>

        </tr>
      </thead>
      <div id="pdf-container"></div>
            <tbody>
            {paiementsUtilisateur.slice(0,4).map((paiement, index) => (
              <tr key={index}>
                <th scope="row" >{index + 1}</th>
                <td>{paiement.reference}</td>
                <td>{paiement.montant.toLocaleString()} F CFA</td>
                <td>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                {paiement.publicationsInfo.map((publication) => (
                  <li key={publication.titre} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                    <img src={publication.image} style={{ width: "20px", height: "30px", border: "1px solid gold", marginRight: "10px" }} alt="Image de la publication" />
                    {publication.titre.length > 20 ? publication.titre.substring(0, 25) + "..." : publication.titre}
                  </li>
                ))}
              </ul>
                </td>
                <td>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                {paiement.publicationsInfo.map((publication) => (
                  <li key={publication.titre} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => showPdf(publication.pdf, publication.titre)}
                    >
                      <i className="fas fa-file-pdf fa-2x"></i>
                    </button>
                  </li>
                ))}
              </ul>
                </td>
                <td>{paiement.datePaiement}</td>
                <td>N/A</td>
              </tr>
            ))}
          </tbody>
        </table> 
            </div>

            <h3 className="mb-4 mt-5" style={{color:"#116BB9"}}>
            <button type="button" class="btn btn-warning btn-lg btn-floating me-3">
            <i class="fas fa-money-bill-1-wave"></i>
                </button>
              Mes commandes en attente de paiement</h3>

            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>
            <div className="table-responsive">
            <table className="table table-striped">
      <thead>
        <tr>
          <th scope="col" style={{color:"#116BB9"}}>#</th>
          <th scope="col" style={{color:"#116BB9"}}>Référence</th>
          <th scope="col" style={{color:"#116BB9"}}>Montant</th>
          <th scope="col" style={{color:"#116BB9"}}>Packages</th>
          <th scope="col" style={{color:"#116BB9"}}>Date de création</th>
          <th scope="col" style={{color:"#116BB9"}}>Action</th>

        </tr>
      </thead>
            <tbody>
            {commandesEnAttente.map((commande, index) => (
              <tr key={index}>
                <th scope="row" >{index + 1}</th>
                <td>{commande.reference}</td>
                <td>{commande.montant.toLocaleString()} F CFA</td>
                <td>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                {commande.publicationsInfo.map((publication) => (
                  <li key={publication.titre} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                    <img src={publication.image} style={{ width: "20px", height: "30px", border: "1px solid gold", marginRight: "10px",  }} alt="Image de la publication" />
                    {publication.titre.length > 20 ? publication.titre.substring(0, 25) + "..." : publication.titre}
                  </li>
                ))}
              </ul>
                </td>
                <td>{commande.dateCreation}</td>
                <td>
                  <Button type="button" variant="warning" onClick={() => Handlepaiementpage(commande.id)}>Payer</Button>
                </td>
              </tr>
            ))}
          </tbody>
            </table>  
            </div>
         </div>
              </Tab>

        <Tab eventKey="paiement" title="Paiements">
        <h3 className="mb-4 mt-5" style={{color:"#116BB9"}}>
        <button type="button" class="btn btn-warning btn-lg btn-floating me-3">
        <i class="fas fa-clipboard"></i>    </button>
          Mes paiements</h3>
                  <div className="row px-0 mb-4">
                    <div className="trait"></div>
                  </div>
            <div className="table-responsive">
            <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col" style={{color:"#116BB9"}}>#</th>
                <th scope="col" style={{color:"#116BB9"}}>Référence</th>
                <th scope="col" style={{color:"#116BB9"}}>Montant</th>
                <th scope="col" style={{color:"#116BB9"}}>Packages</th>
                <th scope="col" style={{color:"#116BB9"}}>Mes documents</th>
                <th scope="col" style={{color:"#116BB9"}}>Date paiement</th>
                <th scope="col" style={{color:"#116BB9"}}>Date d'expiration</th>

        </tr>
      </thead>
            <tbody>
            {paiementsUtilisateur.map((paiement, index) => (
              <tr key={index}>
                <th scope="row" >{index + 1}</th>
                <td>{paiement.reference}</td>
                <td>{paiement.montant.toLocaleString()} F CFA</td>
                <td>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                {paiement.publicationsInfo.map((publication) => (
                  <li key={publication.titre} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                    <img src={publication.image} style={{ width: "20px", height: "30px", borderRadius: "0px", marginRight: "10px" }} alt="Image de la publication" />
                    {publication.titre.length > 20 ? publication.titre.substring(0, 25) + "..." : publication.titre}
                  </li>
                ))}
              </ul>
                </td>
                <td>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                {paiement.publicationsInfo.map((publication) => (
                  <li key={publication.titre} style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => showPdf(publication.pdf, publication.titre)}
                    >
                      <i className="fas fa-file-pdf fa-2x"></i>
                    </button>
                  </li>
                ))}
              </ul>
                </td>
                <td>{paiement.datePaiement}</td>
                <td>N/A</td>
              </tr>
            ))}
          </tbody>
            </table> 
      </div>
    
  </Tab>
  
     {/** End  Informations du paiement */}
     
     <Tab eventKey="profil" title="Profil">

    {/** start  Informations du profil */}

    <Container>
        <Row>
          <Col sm={3} >
          <div className="tab-content">
          <img className="w-100" src="../startup/img/avatar.jpg" alt="Image" />
          </div>
          </Col>

          <Col sm={1} style={{ minHeight: "100px", backgroundColor: "white" }}>

          </Col>
          <Col sm={8} style={{}}>
          <h3 className="mb-4" style={{color:"#116BB9"}}>
          <button type="button" class="btn btn-warning btn-lg btn-floating me-3">
          <i class="fas fa-user"></i>    </button>Informations personnelles</h3>
            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>

            <table className="table table-responsive table-striped">
							<tbody>
								<tr>
									<td scope="row">Nom & Prénoms</td>
									<th>{auth.user?.fullname}</th>
								</tr>
								<tr>
									<td scope="row">E-mail</td>
									<th>{auth.user?.email}</th>
								</tr>
								<tr>
									<td scope="row">Téléphone</td>
									<th>{auth.user?.telephone}</th>
								</tr>
								<tr>
									<td scope="row">Adresse</td>
									<th className="fw-bold">{auth.user?.adresse}</th>
								</tr>
								<tr>
									<td scope="row">Pays</td>
									<th>{paysLibelle ? paysLibelle.nom_pays : '' || ''}</th>
								</tr>
                <tr>
                <td scope="row">Rôle</td>
                <th>
                {roleLibelle}
                </th>
              </tr>

							</tbody>
						</table>
          </Col>
        </Row>
      </Container>

     {/** End  Informations du profil */}

  </Tab>
  <Tab eventKey="deconnexion" title="Se déconnecter">
    <div>
    <p className="mb-4" style={{fontSize:"20px", fontStyle:"italic"}}>Si vous êtes sûr de vous déconnecter, veuillez cliquer sur le bouton</p>
    <Button variant="warning" onClick={handleLogout}>
    Je me déconnecte
  </Button>
    </div>
  </Tab>
</Tabs>

  </div>
</div>
  
  </Layout>
    )
}